import { z } from 'zod'

import { FormError } from '@/utils/localisation'

export const EmailFormSchema = z
  .object({
    email: z.string().email(FormError.EMAIL),
    confirmEmail: z.string().email(FormError.EMAIL),
  })
  .superRefine(({ email, confirmEmail }, ctx) => {
    if (email !== confirmEmail) {
      ctx.addIssue({
        code: 'custom',
        path: ['confirmEmail'],
      })
    }
  })

export type EmailFormSchemaType = z.infer<typeof EmailFormSchema>
